import { Config } from '../quill.interface';
import Quill from 'quill';

export default class Counter {
  quill: Quill;
  options: Config;

  constructor(quillEditor: Quill, options: Config) {
    this.quill = quillEditor;
    this.options = options;
    this.quill.on('editor-change', () => {
      const container = document.querySelector(this.options.container);
      if (!container) {
        return;
      }
      const length = this.calculate();
      const s = length > 1 ? 's' : '';
      container.innerHTML = length + ' ' + this.options.unit + s;
    });
  }

  calculate(): number {
    const text = this.quill.getText().trim();
    if (this.options.unit) {
      return !text ? 0 : text.split(/\s+/).length;
    }
    return text.length;
  }
}
